import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ValidationSteps from '../../components/validation/validation-steps/ValidationSteps';
import { ValidationData } from '../../interfaces/interfaceSteps';

const ValidationContent: React.FC = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [formData, setFormData] = useState<ValidationData>({
    phone: '',
    code: '',
    rut: '',
    dv: '',
    success: false,
    documentNumber: '',
  });

  const redirectToOtherView = () => {
    localStorage.removeItem('accessToken');
    navigate('/');
  };

  const handleNext = () => {
    if (step < 5) {
      setStep(step + 1);
    }
  };

  const handlePrevious = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleChange = (
    field: keyof ValidationData,
    value: string | string[]
  ) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <div className="onboarding">
      <ValidationSteps
        step={step}
        data={formData}
        onChange={handleChange}
        onNext={handleNext}
        onPrevious={handlePrevious}
        redirectToOtherView={redirectToOtherView}
      />
    </div>
  );
};

export default ValidationContent;
